var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn-adicionar-novo",attrs:{"color":"primary","fab":"","middle":"","dark":"","bottom":"","left":""},on:{"click":_vm.adicionarNovo}},[_c('v-icon',[_vm._v("mdi-plus")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }